module.exports = __webpack_public_path__ + "static/img/04.13ecdf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/04.jpg
// module id = dkan
// module chunks = 1